import { ExtendedStudentDetails } from './student-details.interface';

export interface MembershipValidationData {
   id: number;
   uuid: string;
   name: { firstName: string; surname: string; middleName: string };
   taxNumber: string;
   dateOfBirth: Date;
   email: string;
   documents: {
      id: number;
      uuid: string;
      fileName: string;
      createdAt: string;
      updatedAt: string;
      status: string;
      documentType: string; //enum anyway..
   }[];
   language: 'EN' | 'HU';
   type: FormType;
   status: ValidationStatus;
   details?: ExtendedStudentDetails | null; //only attached on app side...

   createdAt: Date;

   syncDate: Date;

   membershipValidDate?: Date | null;

   studentStatus?: PersonStudentStatus | null;

   graduationDate?: string | null;

   institution?: string | null;

   studentIdNumber: string | null;

   grade: string | null;

   faculty: string | null;

   course1: string | null;

   course2: string | null;

   course3: string | null;
}

export enum PersonStudentStatus {
   ACTIVE = 'ACTIVE',
   PASSIVE = 'PASSIVE'
}

export enum ValidationStatus {
   APPLICATION_STARTED = 'APPLICATION_STARTED',
   APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
   FINISHED = 'FINISHED',
   REVISED_WAITING_FOR_SYNC = 'REVISED_WAITING_FOR_SYNC',
   SYNCED = 'SYNCED',
   TRASH = 'TRASH'
}

export enum FormType {
   DATA_SUPPLEMENTATION = 'DATA_SUPPLEMENTATION',
   MEMBERSHIP_VALIDATION = 'MEMBERSHIP_VALIDATION'
}
